import { assetDictionary } from "@dinahmoe/dmafjs-assetloader";
import { webAudioContext } from "./webaudio_context";
import { webAudioUtils } from "./webaudio_utils";
import { NodeHtml } from "./node_html";

class NodeConvolver extends NodeHtml {
  setProps(dnode) {
    dnode.input = webAudioContext.context.createGain();
    dnode.convolver = webAudioContext.context.createConvolver();
    const buffer = assetDictionary.get("assets.buffer." + dnode.props.impulseId);
    if (buffer) {
      dnode.convolver.buffer = buffer;
    } else {
      console.warn("Convolver impulse buffer not loaded:", dnode.props.impulseId);
    }
    dnode.dryLevel = webAudioContext.context.createGain();
    dnode.wetLevel = webAudioContext.context.createGain();
    dnode.output = webAudioContext.context.createGain();

    dnode.input.connect(dnode.dryLevel);
    dnode.dryLevel.connect(dnode.output);
    dnode.input.connect(dnode.convolver);
    dnode.convolver.connect(dnode.wetLevel);
    dnode.wetLevel.connect(dnode.output);

    dnode.dryLevel.gain.value = webAudioUtils.dbToJs(dnode.props.dryLevel);
    dnode.wetLevel.gain.value = webAudioUtils.dbToJs(dnode.props.wetLevel);
    dnode.output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);

    super.setProps(dnode);
  }

  setVolume(dnode) {
    dnode.output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
  }
}

const nodeConvolver = new NodeConvolver("webaudio:node:convolver");
export { nodeConvolver, NodeConvolver };
